/* eslint-disable no-underscore-dangle */
import getConfig from 'next/config';
import { User } from 'src/authentication/models/store';
import { GenericObject } from 'core/models/platform';
import logger from 'core/logger/logger';
import { Learnq } from 'core/models/klavio';
import QuillLocalStorage from 'core/utils/localStorageClient';
import { KLAVIYO_EVENTS } from './constants';

const { publicRuntimeConfig } = getConfig();

class Klavio {
  private klaviyoEvents = KLAVIYO_EVENTS;

  private isUserAuthenticated = false;

  public isKlaviyoActive = false;

  private _learnq: Learnq | undefined;

  private numberOfTries: number;

  constructor() {
    const script = document.createElement('script');
    script.onload = () => {
      this._learnq = window._learnq;
    };
    script.type = 'text/javascript';
    script.defer = true;
    script.src = `//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${publicRuntimeConfig.KLAVIO_COMPANY_ID}`;
    document.head.appendChild(script);
    this.isKlaviyoActive = true;
    this.numberOfTries = 0;
  }

  connect = (user: User) => {
    if (!this.isKlaviyoActive) return;
    if (QuillLocalStorage.getInstance().get('userTrackingAllowed', 'true') === 'false') return;
    logger('Klavio', 'Connecting with Klaviyo');
    if (
      !user ||
      window.location.pathname === '/workshop' ||
      window.location.pathname === '/workshopSuccess' ||
      window.location.pathname === '/student-resources'
    ) {
      return;
    }
    this.isUserAuthenticated = true;

    if (this._learnq) {
      // if (user.providerData)
      this._learnq.push([
        'identify',
        {
          $id: user.uid,
          $email: user.email || '',
          displayName: user.displayName || '',
          fullName: user.fullName || '',
          emailSubscriptionStatus: user.emailSubscriptionStatus,
          emailVerified: user.emailVerified,
          authProvider:
            user.providerData && user.providerData[0] && user.providerData[0].providerId
              ? user.providerData[0].providerId
              : '',
          premium: user.premium,
          paymentMethod: user.paymentMethod || '',
          planLabel: user.planLabel || '',
          dollarValue: user.dollarValue || 0,
          bday: user.bday || '',
          demographic: user.demographic || '',
          englishSpeaker: user.englishSpeaker || '',
          educationLevel: user.educationLevel || '',
          workType: user.workType || [],
          // intent: user.intent || '',
          usageCounts: user.counts || {},
        },
      ]);
      logger('Klavio', 'Connection with Klaviyo Established');
    } else {
      this.numberOfTries += 1;
      if (this.numberOfTries <= 10) {
        setTimeout(() => {
          this.connect(user);
        }, 500);
      } else {
        logger('KLAVIYO', 'Aborting Loading Klaviyo. The script is failing to load.');
      }
    }
  };

  disconnect = () => {
    this.isUserAuthenticated = false;
  };

  /* addIdentityInfo = (info) => {
    if (!isKlaviyoActive) return;
    if (!isUserAuthenticated) return;
    if (this._learnq) {
      if (info && typeof info === 'object') {
        this._learnq.push('identify', info);
      }
    } else {
      setTimeout(() => {
        this.addIdentityInfo(info);
      }, 100);
    }
  }; */

  track = (eventName: string, data: GenericObject, forceSendEvent = false) => {
    /* if (!window.globalFirestore || !window.globalFirestore.user) {
      console.log("global firestore not present");
      return;
    } */
    if (!this.klaviyoEvents.includes(eventName)) return;
    if (!this.isKlaviyoActive) return;
    if (!this.isUserAuthenticated && !forceSendEvent) return;
    if (this._learnq) {
      if (data) {
        this._learnq.push(['track', eventName, data]);
      } else {
        this._learnq.push(['track', eventName]);
      }
      //   console.log("Sending event to Klaviyo");
    } else {
      setTimeout(() => {
        this.track(eventName, data);
      }, 100);
    }
  };
}

let KlavioInstance: Klavio;

export const getKlaviyoInstance = (): Klavio => {
  if (!KlavioInstance) {
    KlavioInstance = new Klavio();
  }
  return KlavioInstance;
};

// export default Klavio;
